import React from 'react';
import FeatureGridPanel from '../../../LandingPage/FeatureGridPanel';
import SectionContainer from '../SectionContainer';

/**
 * Section component for the FeatureGridPanel
 * This allows the FeatureGridPanel to be used within the PageBuilder system
 *
 * @component
 * @param {Object} props
 * @param {string} props.sectionId - ID of the section
 * @param {string} [props.className] - Custom class name
 * @param {string} [props.rootClassName] - Root class name override
 * @param {Array} [props.gridItems] - Array of grid items to display
 * @param {string} [props.title] - Title for the panel
 * @param {number} [props.columns] - Number of columns (default: 6)
 * @param {number} [props.rows] - Number of rows (default: 2)
 * @param {boolean} [props.usePlaceholders] - Whether to use placeholder data
 * @param {boolean} [props.isPersonalized] - Whether listings are personalized based on user search history
 * @param {Object} [props.appearance] - Appearance configuration
 * @param {Object} [props.options] - Additional options
 * @returns {JSX.Element} Section containing FeatureGridPanel
 */
const SectionFeatureGrid = props => {
  const {
    sectionId,
    className,
    rootClassName,
    gridItems = [],
    title,
    columns = 6,
    rows = 2,
    usePlaceholders = true,
    isPersonalized = false,
    debugInfo = null,
    appearance,
    options,
    // Extract React-specific props that don't need to be passed down
    defaultClasses,
    isInsideContainer,
    sectionType,
    sectionName,
    // Any remaining props that might be valid DOM attributes
    ...domProps
  } = props;

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={rootClassName}
      appearance={appearance}
      options={options}
      {...domProps}
    >
      <FeatureGridPanel
        gridItems={gridItems}
        title={title}
        columns={columns}
        rows={rows}
        usePlaceholders={usePlaceholders}
        isPersonalized={isPersonalized}
        debugInfo={debugInfo}
      />
    </SectionContainer>
  );
};

export default SectionFeatureGrid;
